module.exports = __webpack_public_path__ + "static/img/01.fd1ae90.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/lmsj/01.gif
// module id = Xv8/
// module chunks = 0